import { createSlice } from "@reduxjs/toolkit";
import { fetchAppointment } from "../services/appointments";

const initialState = {
  isLoading: false,
  error: null,
  data: [],
};

const appointments = createSlice({
  name: "appointments",
  initialState,
  reducers: {
    fetchStarted: (state) => {
      state.isLoading = true;
    },
    fetchFulfilled: (state, action) => {
      state.isLoading = false;
      state.data = action.payload;
      state.error = null;
    },
    fetchRejected: (state, action) => {
      state.isLoading = false;
      state.error = action.payload;
    },
  },
});

// fetch Thunk
const fetch = (apptID) => async (dispatch) => {
  const { fetchStarted, fetchFulfilled, fetchRejected } = appointments.actions;
  console.log("fetch dispatched...");
  dispatch(fetchStarted());
  try {
    const res = await fetchAppointment(apptID);
    dispatch(fetchFulfilled(res));
  } catch (err) {
    dispatch(fetchRejected(err));
  }
};

export const actions = {
  ...appointments.actions,
  fetch,
};

// selectors;
export const isAppointmentLoading = (state) => state.isLoading;
export const getAppointment = (state) => state.data;
export const getAppointmentError = (state) => state.error;

export default appointments.reducer;
